export function SettingsSVG() {
  return (
    <svg fill="#fff" width="50px" height="50px" viewBox="0 0 24 24">
      <path d="M21.9,10.59,20,8.69V6a2,2,0,0,0-2-2H15.31l-1.9-1.9a2,2,0,0,0-2.82,0L8.69,4H6A2,2,0,0,0,4,6V8.69l-1.9,1.9a2,2,0,0,0,0,2.82L4,15.31V18a2,2,0,0,0,2,2H8.69l1.9,1.9a2,2,0,0,0,2.82,0l1.9-1.9H18a2,2,0,0,0,2-2V15.31l1.9-1.9A2,2,0,0,0,21.9,10.59ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z"></path>
    </svg>
  );
}

export function PeopleSVG() {
  return (
    <svg width="50px" height="50px" viewBox="0 0 28 28" version="1.1">
      <g
        id="🔍-Product-Icons"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="ic_fluent_people_28_filled" fill="#fff" fill-rule="nonzero">
          <path
            d="M4,16 L15,16.001 C16.0538182,16.001 16.9181157,16.8164855 16.9945109,17.8516842 L17,18.001 L17,20.5 C16.999,24.7 12.713,26 9.5,26 C6.35126,26 2.1710504,24.75148 2.00510151,20.7485328 L2,20.5 L2,18 C2,16.9461818 2.81639669,16.0818843 3.85080841,16.0054891 L4,16 Z M17.22,16.001 L24,16 C25.0538182,16 25.9181157,16.8163967 25.9945109,17.8508084 L26,18 L26,20 C25.999,23.759 22.57,25 20,25 C18.942,25 17.741,24.785 16.691,24.275 C17.4432667,23.3808667 17.9315867,22.2428222 17.9933526,20.8112714 L18,20.5 L18,18.001 C18,17.2991818 17.7512397,16.6601736 17.3461307,16.1500909 L17.22,16.001 L24,16 L17.22,16.001 Z M9.5,3 C12.537,3 15,5.463 15,8.5 C15,11.537 12.537,14 9.5,14 C6.463,14 4,11.537 4,8.5 C4,5.463 6.463,3 9.5,3 Z M20.5,5 C22.985,5 25,7.015 25,9.5 C25,11.985 22.985,14 20.5,14 C18.015,14 16,11.985 16,9.5 C16,7.015 18.015,5 20.5,5 Z"
            id="🎨-Color"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export function RefreshSVG() {
  return (
    <svg fill="#fff" height="50px" width="50px" viewBox="0 0 512 512">
      <g>
        <g>
          <g>
            <path
              d="M467.213,153.636c-5.146-10.599-17.91-15.018-28.509-9.872c-10.599,5.147-15.018,17.911-9.872,28.509
				c12.556,25.857,19.169,54.302,19.169,83.716c0,106.042-85.958,192-192,192c-29.272,0-58.057-7.548-84.4-21.323h20.393
				c11.782,0,21.333-9.551,21.333-21.333c0-11.782-9.551-21.333-21.333-21.333h-85.276c-5.218-0.012-10.421,1.892-14.51,5.673
				c-0.225,0.208-0.46,0.406-0.677,0.623c-0.03,0.03-0.063,0.055-0.092,0.085c-0.214,0.218-0.399,0.454-0.602,0.679
				c-0.243,0.27-0.493,0.533-0.722,0.815c-0.228,0.28-0.432,0.573-0.644,0.862c-0.202,0.275-0.409,0.545-0.598,0.829
				c-0.198,0.299-0.374,0.607-0.555,0.914c-0.176,0.296-0.355,0.589-0.517,0.894c-0.156,0.296-0.292,0.598-0.433,0.899
				c-0.158,0.335-0.317,0.667-0.458,1.012c-0.113,0.278-0.208,0.561-0.309,0.843c-0.136,0.379-0.273,0.757-0.388,1.145
				c-0.076,0.259-0.135,0.522-0.201,0.783c-0.106,0.416-0.213,0.831-0.294,1.256c-0.048,0.251-0.077,0.504-0.115,0.757
				c-0.067,0.437-0.137,0.872-0.177,1.317c-0.023,0.25-0.024,0.5-0.038,0.75c-0.022,0.399-0.061,0.794-0.061,1.199v85.333
				c0,11.782,9.551,21.333,21.333,21.333c11.782,0,21.333-9.551,21.333-21.333v-40.429c38.155,25.798,82.362,40.418,128.006,40.418
				c129.606,0,234.667-105.061,234.667-234.667C490.668,220.083,482.574,185.27,467.213,153.636z"
            />
            <path
              d="M63.999,255.991c0-106.028,85.966-192,192-192c29.263,0,58.057,7.558,84.412,21.342h-20.416
				c-11.782,0-21.333,9.551-21.333,21.333c0,11.782,9.551,21.333,21.333,21.333h85.333c0.067,0,0.132-0.009,0.199-0.01
				c0.064-0.001,0.127-0.009,0.191-0.01c5.027-0.091,9.63-1.907,13.232-4.899c0.038-0.032,0.073-0.069,0.111-0.101
				c0.503-0.424,0.988-0.868,1.45-1.337c0.017-0.017,0.036-0.032,0.053-0.049c0.12-0.123,0.221-0.256,0.338-0.381
				c0.346-0.37,0.688-0.743,1.007-1.137c0.186-0.229,0.35-0.468,0.525-0.702c0.238-0.32,0.479-0.638,0.7-0.972
				c0.188-0.285,0.356-0.579,0.529-0.87c0.18-0.302,0.363-0.601,0.528-0.913c0.167-0.316,0.313-0.64,0.464-0.962
				c0.142-0.306,0.289-0.608,0.417-0.921c0.138-0.336,0.254-0.678,0.373-1.02c0.109-0.312,0.224-0.622,0.319-0.94
				c0.109-0.364,0.194-0.733,0.283-1.101c0.073-0.303,0.153-0.604,0.213-0.912c0.083-0.425,0.138-0.852,0.195-1.281
				c0.034-0.258,0.079-0.512,0.104-0.772c0.052-0.547,0.073-1.096,0.083-1.645c0.003-0.134,0.02-0.264,0.02-0.398v-0.132
				c0-0.047,0.001-0.094,0-0.141v-85.06C426.661,9.551,417.11,0,405.328,0c-11.782,0-21.333,9.551-21.333,21.333v40.413
				c-38.163-25.795-82.374-40.422-127.996-40.422C126.4,21.325,21.332,126.4,21.332,255.991c0,35.958,8.099,70.796,23.479,102.445
				c5.15,10.597,17.915,15.013,28.512,9.863c10.597-5.15,15.013-17.915,9.863-28.512C70.616,313.92,63.999,285.456,63.999,255.991z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function PlusSVG() {
  return (
    <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 12H18M12 6V18"
        stroke="#000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function MinusSVG() {
  return (
    <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 12L18 12"
        stroke="#000000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
